import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./App.css";
import AppState from "./context/AppState";
import Router from "./routes/Router";
import Cookies from "js-cookie";
import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "../src/assets/fonts/font.css";
import { useContext } from "react";
import AppContext from "./context/AppContext";
import useAutoUpdate from "./hook/useAutoUpdate";
import { scheduleSessionExpiryCheck, validateSession } from "./utils/authSession";
import { isDesktopApp } from "./utils/isDesktop";
import { initDesktopApiBase } from "./service/CallCenterApi";
import { AppToastCloseButton, AppToastIcon } from "./components/common/AppToast";

function App() {
  const navigate = useNavigate();
  const location = useLocation(); // Get the current route
  // useAutoUpdate()
  const context = useContext(AppContext);
  const { setPriority, setActive, setAreaCode, setSelectedUserId, setAccountNo, langMode } = context;

  useEffect(() => {
    if (isDesktopApp()) {
      initDesktopApiBase().catch(() => undefined);
    }
  }, []);

  useEffect(() => {
    if (isDesktopApp() || !("serviceWorker" in navigator)) {
      return undefined;
    }

    let cancelled = false;
    navigator.serviceWorker
      .register("/firebase-messaging-sw.js")
      .then((registration) => {
        if (!cancelled) {
          console.log("Service Worker registered with scope:", registration.scope);
        }
      })
      .catch((err) => {
        if (!cancelled) {
          console.error("Service Worker registration failed:", err);
        }
      });

    return () => {
      cancelled = true;
    };
  }, []);

  useEffect(() => {
    const handleSessionExpired = () => {
      if (!validateSession()) {
        navigate("/");
      }
    };

    handleSessionExpired();
    const cancelExpiryTimer = scheduleSessionExpiryCheck(handleSessionExpired);

    const onVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        handleSessionExpired();
      }
    };
    document.addEventListener("visibilitychange", onVisibilityChange);

    const interval = setInterval(handleSessionExpired, 60000);

    return () => {
      cancelExpiryTimer();
      document.removeEventListener("visibilitychange", onVisibilityChange);
      clearInterval(interval);
    };
  }, [navigate]);

  useEffect(() => {
    if (!location.pathname.includes("task")) {
      Cookies.remove("mapListFilters")
      sessionStorage.removeItem("taskSearchValue")
      sessionStorage.removeItem("from_Date")
      sessionStorage.removeItem("to_Date")

      setPriority("Priority");
      setActive("Status");
      setSelectedUserId("")
      setAreaCode("")
      setAccountNo("");
    }
  }, [location.pathname, setAccountNo, setActive, setAreaCode, setPriority, setSelectedUserId]);

  const [user] = useState(null);

  return (
    <>
      {/* <AppState> */}
      <Router user={user} />
      <ToastContainer
        position="top-right"
        autoClose={3500}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={langMode === "ar"}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        limit={4}
        icon={AppToastIcon}
        closeButton={AppToastCloseButton}
        toastClassName="app-toast"
        bodyClassName="app-toast-body"
        progressClassName="app-toast-progress"
      />
      {/* </AppState> */}
    </>
  );
}

export default App;
